var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.004a5.82 5.82 0 0 1 2.834 10.904 8.95 8.95 0 0 1 3.497 2.16 8.95 8.95 0 0 1 2.622 6.33.6.6 0 1 1-1.2 0 7.752 7.752 0 0 0-15.506 0 .6.6 0 1 1-1.2 0c0-2.375.944-4.652 2.622-6.33a8.95 8.95 0 0 1 3.497-2.16A5.82 5.82 0 0 1 12 2.004m0 1.2a4.62 4.62 0 1 0 0 9.24 4.62 4.62 0 0 0 0-9.24"
  })));
};
export default SvgUser;